import { Gutter } from 'antd/lib/grid/row';

export const DEFAULT = 'Default';
export const ANY = '(any)';
export const NONE = '(none)';
export const INFINITY_YEAR_FROM = 1;
export const INFINITY_YEAR_TO = 9999;
export const DEFAULT_ROW_GUTTER = 0;
export const DEFAULT_FORM_ROW_GUTTER = [20, 0] as Gutter;
export const ROW_GUTTER = [20, 20] as Gutter;
export const DEFAULT_COLSPAN = '24';
export const HALF_BLOCK_COLSPAN = '12';
// export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_FORMAT_SERVER = 'YYYY-MM-DD';
export const TIME_FORMAT = 'HH:mm:ss.SSS';
export const HH_MM_TIME_FORMAT = 'HH:mm';
export const DEFAULT_TIME_ENDING = '01.001';
export const NOT_LIMITED_DATE = '9999-12-31T20:59:59.999Z';
export const EFFECTIVE = 'effective';
export const LABEL = 'label';
export const MAX_REQUESTS_COUNT = 15;
export const DEFAULT_OFFSET = 0;
export const DEFAULT_LIMIT_PAGINATION = 21;
export const DEFAULT_RULE_SEARCHES_LIMIT_PAGINATION = 11;
export const DEFAULT_TOTAL_ITEMS = 20;
export const DEFAULT_RULE_SEARCHES_TOTAL_ITEMS = 10;
export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_PAGE_SIZE_RULE_SEARCHES = 11;
export const PAGE_SIZE_10 = 10;
export const DEFAULT_RULE_SEARCHES_PAGE_SIZE = 10;
export const DEFAULT_INDENT = 16;
export const SPECIAL_CHARS_REGEX = /[!@#$%^&*()+\-=[\]{};':"\\|,.<>/?]/g;
export const DEFAULT_GUID = '00000000-0000-0000-0000-000000000000';

export const DROP_OPTION_EDIT = { key: 'edit', name: `Edit` };
export const DROP_OPTION_VIEW = { key: 'edit', name: `View` };
export const DROP_OPTION_COPY = { key: 'copy', name: `Copy` };
export const DROP_OPTION_DELETE = { key: 'delete', name: `Delete` };
export const DROP_OPTION_HISTORY = { key: 'history', name: `History` };

export const CONFIRM_DELETE_ITEM_TEXT = 'Are you sure you want to delete this entity?';
export const CONFIRM_SWITCH_TO_INCLUDE_TEXT = 'Are you sure you want to change to include?';
export const CONFIRM_SWITCH_TO_EXCLUDE_TEXT = 'Are you sure you want to change to exclude?';
export const LATITUDE_WARNING = 'Must be in range between -90 and 90';
export const LONGITUDE_WARNING = 'Must be in range between -180 and 180';

export const RESTRICTIONS_TIME_FORMAT = 'HH:mm:ss.SSS';
export const RESTRICTIONS_DATE_FORMAT = 'YYYY-MM-DD';

export type getData = () => void;
export type updateFormData = (value: any) => void;
export type onPageChangeHandler = (page: number) => void;
export type handlePageChange = (page: number) => void;
export type onDeleteRowHandler = (id: string) => Promise<void>;
export type handleDeleteOptionClick = (id: string) => Promise<void>;
export type onSearchClickHandler = () => void;
export type handleSearchButtonClick = () => void;
export type handleTableChange = (pagination: any, filters: any, sorter: any) => void;

export enum METHOD_TYPES {
  GET,
  POST,
  PATCH,
  PUT,
  DELETE,
}

export enum COLUMNS_WIDTH {
  DISABLED = '65px',
  RELEVANCE = '60px',
}

export enum TOOLTIP_TITLES {
  MANDATORY_FIELD = 'This field is mandatory',
}

export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

//to be removed in FLY-12844
export enum BrandIds {
  NetFlights = 4,
  TravelRepublic = 5,
}

//to be removed in FLY-12844
export enum ValidationMessages {
  InstantTicketing = 'Instant Ticketing is not allowed for this brand',
}

// {
//   0: "January",
//   1: "February",
//   2: "March",
//   3: "April",
//   4: "May",
//   5: "June",
//   6: "July",
//   7: "August",
//   8: "September",
//   9: "October",
//   10: "November",
//   11: "December"
// }

export const DISPLAY_TEXT = 'displayText';
export const MIME_TYPES = {
  PDF: 'application/pdf',
  CSV: 'text/csv',
};

export enum Selects {
  Provider = 'provider',
  Supplier = 'supplier',
  BrandAndMarket = 'brandAndMarket',
  BrandAndMarkets = 'brandsAndMarkets',
  CardSupplier = 'cardSupplier',
  Distribution_channel = 'distribution_channel',
  DistributionChannel = 'distributionChannel',
  Fare_type = 'fareType',
  Fare_subtype = 'fareSubtype',
  Weight_unit = 'weightUnit',
  Agency_group = 'agencyGroup',
  Journey_type = 'journeyType',
  Cabin_class = 'cabinClass',
  Relevance = 'relevance',
  Preference = 'Preference',
  AncillaryType = 'ancillaryCategory',
  AncillaryName = 'ancillary',
  AncillaryTypeOriginal = 'ancillaryType',
  AncillaryNameOriginal = 'ancillaryName',
  CardProvider = 'cardProvider',
  Application = 'applicationType',
  Weight = 'weight',
  MarkupType = 'markupType',
  BrandMarket = 'brandMarket',
  MarkupPriority = 'priority',
  AggregatorProvider = 'aggregatorProvider',
  Action = 'allow',
  Basis = 'basis', 
}

export enum Autosuggests {
  Carrier = 'carrier',
  Marketing_carrier = 'marketingCarrier',
  Agency = 'agency',
  Airline = 'airline',
  Location = 'location',
  Operating_carrier = 'operatingCarrier',
  Origin = 'origin',
  Destination = 'destination',
  Country = 'destination',
  City = 'city',
  Airport = 'Airport',
  Departure = 'departure',
  Route = 'route',
  Ticketing_carrier = 'ticketingCarrier',
  OneAirLocation = 'oneAirLocation',
  Distribution_channel = 'distributionChannel',
}

export enum Inputs {
  AgencyName = 'agencyName',
  PhoneNumber = 'phoneNumber',
  Email = 'email',
  Address = 'address',
  CountryDialingCode = 'countryDialingCode',
  StateProvince = 'stateProvince',
  OfficeId = 'officeId',
  IataNumber = 'iataNumber',
  IataCode = 'iataCode',
  IataName = 'iataName',
  IcaOCode = 'icaOCode',
  City = 'city',
  Country = 'country',
  PostalCode = 'postalCode',
  SearchDescription = 'description',
  Description = 'description',
  OSIs = 'OSIs',
  BookingIdRemark = 'bookingIdRemark',
  AbtaNumber = 'abtaNumber',
  Name = 'name',
  Label = 'label',
  FullName = 'fullName',
  Code = 'code',
  Id = 'id',
  DisplayName = 'displayName',
  Latitude = 'latitude', // inputNumber
  Longitude = 'longitude', // inputNumber
  FareBasisCode = 'fareBasisCode',
  TicketDesignator = 'ticketDesignator',
  FlightNumber = 'flightNumber',
  BookingClass = 'bookingClass',
  PassengerAge = 'passengerAge',
  Quantity = 'quantity',
  GrossFare = 'grossFare',
  AccountCode = 'accountCode',
  BaggagePieces = 'baggagePieces',
  BaggageMaxWeight = 'baggageMaxWeight',
  MarketingFlightNumber = 'marketingFlightNumber',
  OperatingFlightNumber = 'operatingFlightNumber',
  Timeout = 'timeout',
  MarkupAmount = 'markupAmount', // inputNumber
  MarkupPercentage = 'markupPercentage', // inputNumber
  Supplier = 'supplier',
  MaxPriceSolutions = 'maxPriceSolutions',
  MaxPricePoints = 'maxPricePoints',
  Search_description = 'search_description',
  Details = 'details',
  correlationId = 'correlationId',
  fareBasisPattern = 'fareBasisPattern',
  Class = 'class',
  DayOffset = 'dayOffset',
  OverrideDays = 'overrideDays',
  Time = 'time',
  FilterKeyword = 'filterKeyword',
  SupplierAncillaryCode = 'ancillarySupplierCode',
  SupplierValue = 'supplierValue',
  Agency = 'agency',
  Carrier = 'carrier',
  Comment = 'comment',
  APIKey = 'apiKey',
  Server = 'server',
  ClientId = 'clientId',
  Consumer = 'consumer',
  URL = 'url',
  BookerId = 'bookerId',
  Password = 'password',
  AgentId = 'agentId',
  Zip = 'zip',
  Address1 = 'addressLine1',
  Address2 = 'addressLine2',
  Ctce = 'contactEmail',
  Ctcm = 'contactMobile',
  Relevance = 'relevance',
  Currency = 'currency',
  ToleranceAmountUp = 'toleranceAmountUp',
  ToleranceAmountDown = 'toleranceAmountDown',
  AncillaryName = 'ancillaryName',
  AncillaryAPIName = 'apiName',
  SupplierIdentityCode = 'providerIdentityCode',
  UserName = 'username',
  OrganisationId = 'organisationId',
  MerchantId = 'merchantId',
  BankId = 'bankId',
  CompanyId = 'companyId',
  AdditionalInformation = 'additionalInformation',
  OffsetDays = 'offsetDays',
}

export enum TextAreas {
  Comment = 'comment',
}

export enum Checkboxes {
  Disabled = 'disabled',
  Enabled = 'enabled',
  IncludeDisabled = 'includeDisabled',
  IncludeDeleted = 'includeDeleted',
  ShowExpired = 'showExpired', //need to check after server changes
  AgencyOnly = 'agencyOnly',
  ShowDisabled = 'showDisabled',
  ShowDeleted = 'showDeleted',
  SelectCurrentPage = 'selectCurrentPage',
  SelectAllPages = 'selectAllPages',
  IsMixAndMatchProvider = 'isMixAndMatchProvider',
  IsActive = 'isActive',
}

export enum DatesRange {
  EffectiveFrom = 'effectiveFrom',
  EffectiveTo = 'effectiveTo',
  EffectiveDateFrom = 'effectiveDateFrom',
  EffectiveDateTo = 'effectiveDateTo',
}

export enum Collapses {
  Collapse = 'collapse',
  JourneyType = 'journeyType',
  SalesJourneys = 'salesJourneys',
  DistributionChannels = 'distributionChannels',
  AgenciesAndGroups = 'agenciesAndGroups',
  Routes = 'routes',
  Suppliers = 'suppliers',
  TravelDates = 'travelDates',
  DateTimeRestrictions = 'bookingDateTimeRestrictions',
  Carriers = 'marketingCarriers',
  BookingToleranceCarriers = 'carriers',
  SMDateTimeRestrictions = 'dateTimeRestrictions',
  AccountCodes = 'accountCodes',
  FareBasisCodes = 'fareBasisCodes',
  CarriersSSR = 'carriers',
  BookingClass = 'markupBookingClasses',
  Basis = 'includeTax',
  PassengerAge = 'passengerAges',
  TicketDesignators = 'ticketDesignators',
  FlightNumbers = 'flightNumbers',
  BookingClasses = 'bookingClasses',
  MarketingFlightNumbers = 'marketingFlightNumbers',
  FareBases = 'fareBases',
}

export enum Containers {
  ShowBlock = 'showBlock',
  ButtonsBlock = 'buttonsBlock',
}

export enum Cards {
  DistributionChannels = 'distributionChannels',
  SalesJourneys = 'salesJourneys',
  Suppliers = 'providers',
  FareTypes = 'fareTypes',
  CabinClass = 'cabinClasses',
  MixAndMatchProviders = 'mixAndMatchProviders',
}

export enum ManagableCards {
  OSIs = 'osIs',
}

export enum Buttons {
  Clear = 'clear',
  Search = 'search',
  Delete = 'delete',
  SaveChanges = 'saveChanges',
  Export = 'export',
}

export enum BindProperties {
  Supplier = 'supplier',
  BrandAndMarket = 'brandAndMarket',
  Providers = 'providers',
  AncillaryCategory = 'ancillaryCategory',
}

//Keys for RestClient object
export enum SectionKeys {
  GeoGroups = 'geoGroups',
  Supplier = 'providers',
  SearchManager = 'searchManager',
  AncillariesMapping = 'ancillariesMapping',
  AncillariesManager = 'ancillariesManager',
  AncillaryDistribution = 'ancillaryDistribution',
  VccCredentials = 'vccCredentials',
  SearchManagerV2 = 'searchManagerV2',
  TTLOV2 = 'ttloV2',
  GlobalFiltersV2 = 'globalFiltersV2',
  SSR = 'bookingCreateManagerSSR',
  BookingCreateManagerV2 = 'bookingCreateManagerV2',
  BookingCreateManagerV2Remarks = 'bookingCreateManagerV2Remarks',
  BookingCreateManagerV2SSR = 'bookingCreateManagerV2SSR',
  BookingTolerances = 'bookingTolerances',
  MarkupsV2 = 'markupV2',
}

export enum ConfigurationMethods {
  GeoGroupsForm = 'apiSupplierLocationMappingFormConfigurationGet',
  GeoGroupsList = 'apiSupplierLocationMappingListConfigurationGet',
  SearchManagerForm = 'apiSearchManagerV2SearchRuleFormFormConfigurationGet',
  SearchManagerList = 'apiSearchManagerV2SearchRuleListGetListConfigurationGet',
  TTLOList = 'apiTicketTLOV2TTLOV2ListGetListConfigurationGet',
  TTLOForm = 'apiTicketTLOV2TTLOV2FormFormConfigurationGet',
  GlobalFiltersV2List = 'apiGlobalFiltersV2GlobalFilterRuleListGetListConfigurationGet',
  GlobalFiltersV2Form = 'apiGlobalFiltersV2GlobalFilterRuleFormFormConfigurationGet',
  AncillariesSupplierList = 'apiAncillarySupplierListConfigurationGet',
  AncillariesManagerList = 'apiAncillaryManagerListConfigurationGet',
  AncillariesManagerForm = 'apiAncillaryManagerFormConfigurationGet',
  AncillariesSupplierForm = 'apiAncillarySupplierFormConfigurationGet',
  AncillaryDistributionList = 'apiAncillaryDistributionListConfigurationGet',
  AncillaryDistributionForm = 'apiAncillaryDistributionFormConfigurationGet',
  VccCredentialsList = 'apiVccCredentialsListConfigurationGet',
  VccCredentialsForm = 'apiVccCredentialsFormConfigurationGet',
  BCMSSRList = 'apiSSRRuleListConfigurationGet',
  BCMSSRForm = 'apiSSRRuleFormConfigurationGet',
  BookingCreateManagerList = 'apiBookingCreateManagerOsisV2OsisRuleListGetListConfigurationGet',
  BookingCreateManagerForm = 'apiBookingCreateManagerOsisV2OsisRuleFormConfigurationGet',
  BookingCreateManagerRemarksList = 'apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleListGetListConfigurationGet',
  BookingCreateManagerRemarksForm = 'apiBookingCreateManagerBookingIdRemarkV2BookingIdRemarkRuleFormConfigurationGet',
  BookingCreateManagerSSRList = 'apiBookingCreateManagerSSRV2SSRRuleListGetListConfigurationGet',
  BookingCreateManagerSSRForm = 'apiBookingCreateManagerSSRV2SSRRuleFormConfigurationGet',
  BookingTolerancesList = 'apiBookingTolerancesBookingTolerancesListConfigurationGet',
  BookingTolerancesForm = 'apiBookingTolerancesBookingTolerancesFormConfigurationGet',
  SupplierForm = 'apiProviderFormConfigurationGet',
  MarkupList = 'apiMarkupV2MarkupV2ListGetListConfigurationGet',
  MarkupFilters = 'apiMarkupsV2MarkupsV2FormFormConfigurationGet',
}

export enum LayoutTypes {
  RuleInfo = 'ruleInfo',
  AppliesTo = 'appliesTo',
}

export enum ItemTypes {
  Input = 'input',
  Select = 'select',
  AutoSuggest = 'autoSuggest',
  CheckBox = 'checkbox',
  DateRange = 'dateRange',
}

export enum CardBlockContentTypes {
  DistributionChannels = 'distributionChannels',
  JourneyTypes = 'journeyTypes',
  AgenciesAndGroups = 'agenciesAndGroups',
  Routes = 'routes',
  TravelDates = 'travelDates',
  Suppliers = 'suppliers',
  BookingDate = 'bookingDate',
  Carriers = 'carriers',
}

export enum CardBlockTypes {
  ContentOnly = 'contentOnly',
  SimpleBlock = 'simpleBlock',
}

export enum TabTypes {
  FiltersTable = 'filtersTable',
  AppliesTo = 'appliesTo',
  SubRules = 'subRules',
}

export enum HandlerTypes {
  Select = 'select',
  AutoSuggest = 'autoSuggest',
  Input = 'input',
}

export enum TableColumns {
  Description = 'description',
  Comment = 'comment',
  BrandAndMarket = 'brandAndMarket',
  DistributionChannels = 'distributionChannels',
  Channels = 'Channels',
  Suppliers = 'suppliers',
  Relevance = 'relevance',
  State = 'state',
  Group = 'group',
  Agency = 'agency',
  To = 'to',
  From = 'from',
  Country = 'country',
  Region = 'region',
  Location = 'location',
  Station = 'station',
  FromRegion = 'fromregion',
  FromCountry = 'fromcountry',
  FromLocation = 'fromlocation',
  FromStation = 'fromstation',
  ToRegion = 'toregion',
  ToCountry = 'tocountry',
  ToLocation = 'tolocation',
  ToStation = 'tostation',
  Match = 'match',
  DateRanges = 'dateRanges',
  TimeRanges = 'timeRanges',
  WeekDays = 'weekDays',
  Comments = 'comments',
  Exclude = 'exclude',
  RemoveRecord = 'removeRecord',
  MarketingCarriers = 'marketingCarriers',
  FareTypes = 'fareTypes',
  Osis = 'osIs',
  Priority = 'priority',
  Supplier = 'supplier',
  MaxPriceSolutions = 'maxPriceSolutions',
  MaxPricePoints = 'maxPricePoints',
  Details = 'details',
  PermittedCarriers = 'permittedCarriers',
  PreferredCarriers = 'preferredCarriers',
  ProhibitedCarriers = 'prohibitedCarriers',
  MaxConnectionTime = 'maxConnectionTime',
  DirectFligtsOnly = 'directFlightsOnly',
  ExcludeDoubleConnections = 'excludeDoubleConnections',
  RestrictMultiAirportConnections = 'restrictMultiAirportConnections',
  ExcludeBaglessFares = 'excludeBaglessFares',
     AgeRange = 'ageRange',
     FromFlightNumber = 'fromFlightNumber',
     ToFlightNumber = 'toFlightNumber',
     Carriers = 'carriers',
     IsOutbound = 'isOutbound',
     Code = 'code',
     TicketDesignator = 'ticketDesignator',
     CTCE = 'contactEmail',
     CTCM = 'contactMobile',
     OverrideDays = 'overrideDays',
     DayOffset = 'offsetDays',
     AccountCodes = 'accountCodes',
  }

export enum Tables {
  AccountCodes = 'accountCodes',
  RuleSearchesTable = 'ruleSearchesTable',
  CardPoolSettings = 'cardPoolSettings',
}

export enum ActionOptions {
  Edit = 'Edit',
  View = 'View',
  Copy = 'Copy',
  History = 'History',
  Delete = 'Delete',
  Enable = 'Enable',
  Disable = 'Disable',
  Unsaved = 'Unsaved',
  BulkUpdate = 'Bulk Update',
}

//enum Collapse for new design
export enum CollapseItemTypes {
  AgencyAndAgencyGroups = 'agencyAndAgencyGroups',
  TravelDates = 'travelDates',
  Routes = 'routes',
  Restrictions = 'restrictions',
  Carriers = 'carriers',
  AccountCodes = 'accountCodes',
  FareBasisCodes = 'fareBasisCodes',
  BookingClass = 'bookingClass',
  Basis = 'basis',
  PassengerAge = 'passengerAge',
  TicketDesignators = 'ticketDesignators',
  FlightNumbers = 'flightNumbers',
  MarketingFlightNumbers = 'marketingFlightNumbers',
  FareBases = 'fareBases',
  MarketingAndOperatingCarriers = 'marketingAndOperatingCarriers',
}

export enum SubRuleTypes {
  SearchManager = 'searchManager',
}

export enum SubRuleBusinessDataTypes {
  PrefferedCarriers = 'preferredCarriers',
  PermittedCarriers = 'permittedCarriers',
  ProhibitedCarriers = 'prohibitedCarriers',
  UndesirableConnectionPoints = 'undesirableConnectionPoints',
  AccountCodes = 'accountCodes',
}

export enum TimezoneDataKeys {
  DateTimeRestrictionsTimeZone = 'dateTimeRestrictionsTimeZone',
  BookingDateTimeRestrictionsTimeZone = 'bookingDateTimeRestrictionsTimeZone',
}

export enum ThemeConfigKeys {
  DefaultTheme,
  DefaultThemeSecondary,
  DnataBlue,
  DnataBlueCheckbox,
  DnataBlueSecondaryBtn,
  DnataBlueCustomCollapseBtn,
  DnataBlueCloseBtn,
  DnataBlueLinkBtn,
  SearchSubRuleForm,
  RouteModalForm,
  DnataBlueSmallControl,
}

export const DEFAULT_THEME = {
  token: {
    colorPrimary: '#1890ff',
    borderRadius: 2,
  },
};

export const DEFAULT_THEME_SECONDARY = {
  token: {
    colorPrimary: 'rgba(139,194,91,0.9)',
    borderRadius: 2,
    colorBgContainerDisabled: '#D3D3D3',
    colorTextDisabled: '#ffffff',
  },
};

export const DnataBluePrimaryColor = '#2d9cdb';
export const DnataBlueFontFamily = 'Inter,sans-serif';

const dnataBlueBasic = {
  colorPrimary: DnataBluePrimaryColor,
  fontFamily: DnataBlueFontFamily,
  fontSize: 12,
};

const commonControlTokens = {
  controlHeight: 40,
  borderRadius: 6,
  colorText: '#212b51',
};

export const DNATA_BLUE = {
  token: {
    colorPrimary: DnataBluePrimaryColor,
    colorPrimaryText: DnataBluePrimaryColor,
    colorLink: DnataBluePrimaryColor,
    colorInfo: DnataBluePrimaryColor,
    colorInfoText: DnataBluePrimaryColor,
    fontFamily: DnataBlueFontFamily,
    borderRadius: 2,
    colorPrimaryActive: DnataBluePrimaryColor,
  },
  components: {
    Select: {
      ...commonControlTokens,
    },
    Input: {
      ...commonControlTokens,
    },
    AutoComplete: {
      ...commonControlTokens,
    },
    Button: {
      colorTextDisabled: 'rgba(255, 255, 255,0.3)',
      fontSize: 13,
      borderRadius: 3,
      colorBgContainerDisabled: 'rgba(45, 156, 219,0.3)',
      colorBorder: 'transparent',
    },
    Table: {
      colorText: '#2e3b52',
    },
    Checkbox: {
      borderRadius: 4,
    },
    Pagination: {
      fontSize: 13,
    },
    Tabs: {
      fontSize: 13,
    },
    Modal: {
      paddingMD: 0,
      paddingContentHorizontalLG: 0,
    },
    Radio: {
      colorBorder: DnataBluePrimaryColor,
      colorWhite: DnataBluePrimaryColor,
      colorPrimary: '#ffffff',
      controlHeight: 40,
      colorPrimaryBorder: DnataBluePrimaryColor,
      size: 32,
    },
  },
};

export const DNATA_BLUE_CHECKBOX = {
  token: {
    colorPrimary: DnataBluePrimaryColor,
    fontFamily: DnataBlueFontFamily,
    borderRadius: 4,
    colorBorder: DnataBluePrimaryColor,
  },
  inherit: false,
};

export const DNATA_BLUE_SECOND_BTN = {
  token: {
    colorPrimary: '#e96f6f',
    borderRadius: 3,
    colorBgContainerDisabled: 'rgb(233 111 111 / 30%)',
    colorTextDisabled: 'rgb(255 255 255 / 30%)',
    colorBorder: 'transparent',
  },
  inherit: false,
};

export const DNATA_BLUE_CUSTOM_COLLAPSE_BTN = {
  token: {
    colorPrimary: DnataBluePrimaryColor,
    colorTextDisabled: '#ffffff',
    fontSize: 11,
    borderRadius: 3,
    colorBgContainerDisabled: 'rgba(45, 156, 219,0.3)',
    controlHeight: 24,
    fontFamily: DnataBlueFontFamily,
    colorBorder: 'transparent',
  },
  inherit: false,
};

export const DNATA_BLUE_CLOSE_BTN = {
  token: {
    colorPrimary: DnataBluePrimaryColor,
    colorTextDisabled: '#ffffff',
    fontSize: 11,
    borderRadius: 3,
    colorBgContainerDisabled: 'rgba(45, 156, 219,0.3)',
    controlHeight: 24,
    fontFamily: DnataBlueFontFamily,
  },
  inherit: false,
};

export const DNATA_BLUE_LINK_BTN = {
  token: {
    colorPrimary: DnataBluePrimaryColor,
    colorLink: DnataBluePrimaryColor,
    colorBgContainerDisabled: 'rgba(45, 156, 219,0.3)',
    fontFamily: DnataBlueFontFamily,
    colorTextDisabled: 'rgba(45, 156, 219,0.3)',
    fontSize: 11,
  },
  inherit: false,
};

export const DNATA_SEARCH_SUB_RULE = {
  token: {
    colorPrimary: DnataBluePrimaryColor,
    fontFamily: DnataBlueFontFamily,
    fontSize: 12,
    colorText: '#5D6598',
    colorBorder: DnataBluePrimaryColor,
    colorTextPlaceholder: '#212B51',
  },
};

export const DNATA_BLUE_ROUTE_MODAL = {
  token: {
    colorPrimary: DnataBluePrimaryColor,
    fontFamily: DnataBlueFontFamily,
    fontSize: 12,
    colorText: '#5D6598',
    colorBorder: DnataBluePrimaryColor,
    colorTextPlaceholder: '#212B51',
  },
};

export const DNATA_BLUE_SMALL_CONTROL = {
  token: {
    ...dnataBlueBasic,
  },
  components: {
    Input: {
      ...commonControlTokens,
      controlHeight: 24,
    },
    Select: {
      ...commonControlTokens,
      controlHeight: 24,
    },
  },
};

export const ThemeConfigs = {
  [ThemeConfigKeys.DefaultTheme]: DEFAULT_THEME,
  [ThemeConfigKeys.DefaultThemeSecondary]: DEFAULT_THEME_SECONDARY,
  [ThemeConfigKeys.DnataBlue]: DNATA_BLUE,
  [ThemeConfigKeys.DnataBlueCheckbox]: DNATA_BLUE_CHECKBOX,
  [ThemeConfigKeys.DnataBlueSecondaryBtn]: DNATA_BLUE_SECOND_BTN,
  [ThemeConfigKeys.DnataBlueCustomCollapseBtn]: DNATA_BLUE_CUSTOM_COLLAPSE_BTN,
  [ThemeConfigKeys.DnataBlueCloseBtn]: DNATA_BLUE_CLOSE_BTN,
  [ThemeConfigKeys.DnataBlueLinkBtn]: DNATA_BLUE_LINK_BTN,
  [ThemeConfigKeys.SearchSubRuleForm]: DNATA_SEARCH_SUB_RULE,
  [ThemeConfigKeys.RouteModalForm]: DNATA_BLUE_ROUTE_MODAL,
  [ThemeConfigKeys.DnataBlueSmallControl]: DNATA_BLUE_SMALL_CONTROL,
};

export enum AncillaryType {
  HoldBag = 0,
  Meals = 1,
  SportEquipment = 2,
  Seat = 3,
  PriorityBoarding = 4,
  Other = 5,
}

export enum ScreensV2 {
  SearchManagerV2 = 'searches-manager',
  TicketTLO = 'ticket-tlo',
  GlobalFilters = 'global-filters',
  BookingCreateManagerV2 = 'booking-create-manager',
  MarkupsV2 = 'markups',
  ShoppingDiagnosticsV2 = 'shopping-diagnostics',
}
